if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

    }
    
    connectedCallback() {
      // console.log('this', this);
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        slider: this.querySelector('[id^="Slider-Gallery-"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      // if (!this.elements.thumbnails) return;

      // this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      if (this.dataset.desktopLayout === 'stacked') {
        this.initSlider();
        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });
        }
      } else {
        setTimeout(() => this.initSlider(), 1);
        setTimeout(() => window.dispatchEvent(new Event('resize')), 200);
        // this.initSlider();
      }

      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    initSlider() {
      let config = JSON.parse(this.elements.slider.getAttribute('data-flickity-config'));
      // console.log(this.flckty);
      if (this.flckty) this.flckty.destroy();
      
      this.flckty = new Flickity(this.elements.slider, config);

      this.flckty.on('change', debounce(this.onSlideChanged.bind(this), 500));

      if (!this.elements.thumbnails) return;
      let thumbsSlider = this.elements.thumbnails.querySelector('[data-flickity-config]')
      let thumbsConfig = JSON.parse(thumbsSlider.getAttribute('data-flickity-config'));
      try {
        // console.log(this.thumbsFlckty);
        if (this.thumbsFlckty) this.thumbsFlckty.destroy();
        this.thumbsFlckty = new Flickity(thumbsSlider, thumbsConfig);
      } catch (e) {
        console.log(e);
      }

    }

      onSlideChanged(index) {
        const activeMedia = this.elements.slider.querySelectorAll(('.flickity-slider [id^="Slide-"]'))[index];
        const activeMediaId = activeMedia.dataset.mediaId;
        this.setActiveMedia(activeMediaId, false);
        const thumbnail = this.elements.thumbnails.querySelectorAll('[id^="Slide-Thumbnails-"]')[index];
        this.setActiveThumbnail(thumbnail);
      }

    setActiveMedia(mediaId, prepend) {
      console.log('mediaId', mediaId);
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      // this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
      //   element.classList.remove('is-active');
      // });
      // activeMedia.classList.add('is-active');

      if (prepend) {
        if (this.dataset.desktopLayout === 'stacked') {
          activeMedia.parentElement.prepend(activeMedia);
        } else {
          this.flckty.slider.prepend(activeMedia);
        }

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          if (this.dataset.desktopLayout === 'stacked') {
            activeThumbnail.parentElement.prepend(activeThumbnail);
          } else {
            this.thumbsFlckty.slider.prepend(activeThumbnail);
          }
          if (this.thumbsFlckty) this.reloadSlider(this.thumbsFlckty);
        }
        if (this.flckty) this.reloadSlider(this.flckty);
      }
      //  else if (this.dataset.desktopLayout !== 'stacked') {
      //   this.selectSlide(mediaId);
      // }

      this.preventStickyHeader();
      window.setTimeout(() => {
        // if (this.elements.thumbnails) {
        //   activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        // }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      this.elements.thumbnails.querySelector('.is-selected button').setAttribute('aria-current', true);
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    reloadSlider(flckty) {
      flckty.reloadCells();
      flckty.reposition();
      flckty.resize();
      if (!flckty.options.asNavFor) {
        setTimeout(() => {
          // var el = flckty.element;
          // var config = flckty.options;
          // flckty.destroy();
          // this.flckty = new Flickity(el, config)
          flckty.select(0);
        }, 100);
      }
    }

    // selectSlide(mediaId) {
    //   const sliderCells = this.elements.slider.querySelectorAll('.flickity-slider > .product__media-item');
    //   const newActiveMedia = this.elements.slider.querySelector('.flickity-slider > .product__media-item[data-media-id="'+ mediaId +'"]');
    //   const currentActiveThumb = this.elements.thumbnails.querySelector('.thumbnail-list__item.is-selected')
    //   if (currentActiveThumb) currentActiveThumb.classList.remove('is-selected');
    //   this.elements.thumbnails.querySelector('.thumbnail-list__item[data-target="'+ mediaId +'"]').classList.add('is-selected');
    //   this.flckty.select(Array.from(sliderCells).indexOf(newActiveMedia));
    // }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
